<template>
  <div
    class="modal"
    id="agendaFiltersModalVue"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content text-black">
        <div class="modal-header">
          <h5 class="modal-title">Filters</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <!-- day -->
              <div class="form-group" v-if="filters?.days?.length > 1">
                <label for="days" class="control-label">Day</label>
                <select
                  id="days"
                  class="form-control"
                  v-model="searchFilters.days"
                >
                  <option value="">All</option>
                  <option v-for="(option, index) in filters.days" :key="`days-option-${index}`" :value="option.value">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- types -->
              <div class="form-group">
                <label for="types" class="control-label">Content Type</label>
                <select
                  id="types"
                  class="form-control"
                  v-model="searchFilters.types"
                >
                  <option value="">All</option>
                  <option v-for="(option, index) in filters.types" :key="`types-option-${index}`" :value="option.value">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- visiting_types -->
              <div class="form-group" v-if="filters?.visiting_types?.length > 1">
                <label for="visiting_types" class="control-label">Visiting Types</label>
                <select
                  id="visiting_types"
                  class="form-control"
                  v-model="searchFilters.visiting_types"
                >
                  <option value="">All</option>
                  <option v-for="(option, index) in filters.visiting_types" :key="`visiting_types-option-${index}`" :value="option.value">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- formats -->
              <div class="form-group" v-if="filters?.formats?.length">
                <label for="formats" class="control-label">Session Format</label>
                <select
                  id="formats"
                  class="form-control"
                  v-model="searchFilters.formats"
                >
                  <option value="">All</option>
                  <option v-for="(option, index) in filters.formats" :key="`formats-option-${index}`" :value="option.value">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- rooms -->
              <div class="form-group" v-if="filters?.rooms?.length">
                <label for="rooms" class="control-label">Rooms</label>
                <select
                  id="rooms"
                  class="form-control"
                  v-model="searchFilters.rooms"
                >
                  <option value="">All</option>
                  <option v-for="(option, index) in filters.rooms" :key="`rooms-option-${index}`" :value="option.value">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- tracks -->
              <div class="form-group" v-if="filters?.tracks?.length">
                <label for="tracks" class="control-label">Tracks</label>
                <select
                  id="tracks"
                  class="form-control"
                  v-model="searchFilters.tracks"
                >
                  <option value="">All</option>
                  <option v-for="(option, index) in filters.tracks" :key="`tracks-option-${index}`" :value="option.value">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer footer-btn-actions">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          ><i class="fa-regular fa-close"></i> Close</button>

          <div>
            <button
              type="button"
              class="btn btn-secondary"
              @click="onHandleClearFilters()"
            ><i class="fa-regular fa-filter-slash"></i> Clear All Filters</button>

            <button
              type="button"
              class="btn btn-primary"
              @click="onHandleRunFilters()"
            ><i class="fa-regular fa-filter"></i> Filter</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFetching: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => {}
    },
    searchFilters: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.initModal();
  },
  methods: {
    onHandleRunFilters() {
      this.$emit('update:searchFilters', this.searchFilters);

      this.$emit('search');
      // this.onHandleSearch();

      $('#agendaFiltersModalVue').modal('hide');
    },

    onHandleClearFilters() {
      this.$emit('clear');
      $('#agendaFiltersModalVue').modal('hide');
    },


    initModal() {
      // Close modal with key ESC
      $("#agendaFiltersModalVue").modal({
        show: false,
        backdrop: 'static'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-btn-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
